module.exports = __webpack_public_path__ + "img/renewal_course_4.0de33869.png";